import React from 'react';
import { useMediaQuery } from 'react-responsive'
import styled from 'styled-components';
import { ContributingFactorsMobileRow1, ContributingFactorsMobileRow2 } from './ContributingFactors'
import SvgSelector from '../helpers/SvgSelector';
import { colors, breakpoints } from '../styles/utilities/settings';
const temp = number => {
  let color = colors.gray;

  if (number <= 29) {
    color = colors.green;
  } else if (number >= 30 && number <= 59) {
    color = colors.yellow;
  } else if (number >= 61 && number <= 100) {
    color = colors.red;
  }

  return color;
};

const getIcon = name => {
  let iconName = '';

  if (name === 'Cockroach') {
    iconName = 'roach';
  } else if (name === 'Large Fly') {
    iconName = 'fly';
  } else if (name === 'Small Fly') {
    iconName = 'small-fly';
  } else if (name === 'Rodent') {
    iconName = 'mouse';
  }

  return iconName;
};

const IconBlock = ({ icon, color, number, copy }) => (
  <SIconBlock>
    <SvgSelector icon={icon} width={45} color={color} />
    <span>{number}</span>
    <p>{copy}</p>
  </SIconBlock>
);

const Scores = ({ results }) => {
  const isTabletOrMobile = useMediaQuery({ query: `(max-width: ${breakpoints.ipadPort - 1}px)` })

  return (
  <SScores>
    <div className="icons">
    {results.length !== 0 &&
      <>
        <IconBlock
          icon={getIcon(results[2].PestTypeOverallPest)}
          color={temp(Math.round(results[2].PestRiskProbability))}
          number={Math.round(results[2].PestRiskProbability)}
          copy={`${results[2].PestTypeOverallPest} Pressure`}
        />
        <IconBlock
          icon={getIcon(results[3].PestTypeOverallPest)}
          color={temp(Math.round(results[3].PestRiskProbability))}
          number={Math.round(results[3].PestRiskProbability)}
          copy={`${results[3].PestTypeOverallPest} Pressure`}
        />
        {isTabletOrMobile &&
          <ContributingFactorsMobileRow1 />
        }
        <IconBlock
          icon={getIcon(results[0].PestTypeOverallPest)}
          color={temp(Math.round(results[0].PestRiskProbability))}
          number={Math.round(results[0].PestRiskProbability)}
          copy={`${results[0].PestTypeOverallPest} Pressure`}
        />
        <IconBlock
          icon={getIcon(results[1].PestTypeOverallPest)}
          color={temp(Math.round(results[1].PestRiskProbability))}
          number={Math.round(results[1].PestRiskProbability)}
          copy={`${results[1].PestTypeOverallPest} Pressure`}
        />
      </>
      }
      {isTabletOrMobile &&
        <ContributingFactorsMobileRow2 />
      }
    </div>
  </SScores>

)};

export default Scores;

const SIconBlock = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  align-items: center;
  padding: 5px;

  span {
    font-size: 28px;
    margin-left: 10px;
  }

  p {
    width: 100%;
    margin: 5px 0 0 !important;
    font-size: 12px;
  }
`;

const SScores = styled.div`
  margin-top: 20px;

  .icons {
    display: flex;
    justify-content: space-between;
    align-items: center;

    @media screen and (max-width: ${breakpoints.ipadPort - 1}px) {
      flex-wrap: wrap;
    }
  }

  ${SIconBlock} {
    box-sizing: border-box;

    @media screen and (max-width: ${breakpoints.ipadPort - 1}px) {
      width: 50%;
      margin-bottom: 20px;
    }

    + ${SIconBlock} {
      @media screen and (min-width: ${breakpoints.ipadPort}px) {
        border-left: 1px solid ${colors.middleGray};
      }
    }
  }
`;
